export default __webpack_public_path__ + "images/favicon/android-chrome-192x192.png";